<template>
  <div id="extend-segment-duration">
    <b-modal
      ref="extendSegmentDuration"
      id="modal-extend-segment-duration"
      :noCloseOnBackdrop="true"
      :noCloseOnEsc="true"
      hide-footer
      centered
    >
      <template v-slot:modal-header>
        <h5>Durée du segment invalide!</h5>
      </template>

      <div class="d-block text-center mb-4">
        <h3>Voulez vous étendre ou couper le segment?</h3>
      </div>
      <b-button variant="outline-primary" size="xl" class="mr-3" @click="extend">
        étendre
      </b-button>
      <b-button variant="outline-primary" size="xl" @click="crop">
        Couper
      </b-button>
      <!--<template v-slot:modal-footer>

      </template>-->
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import mixin from '../../mixins/Mixin.js';

export default {
  name: 'ExtendSegmentDuration',
  data() {
    return {
      duration: 0,
      uid: 0,
      showCrop: true,
    };
  },
  computed: {
    ...mapGetters({
      startGeneric: 'segments/getStartGeneric',
    }),
  },
  mixins: [mixin],
  methods: {
    ...mapActions('segments', [
      'cropVideoFromSegment',
      'appendBlankSlideToSegment',
      'FixdurationVideoFromSegment',
      'updateSegmentDuration',
    ]),
    extend() {
      this.appendBlankSlideToSegment(this.uid);
      this.$refs.extendSegmentDuration.hide();
      document.getElementById('close-modal-image') &&
        document.getElementById('close-modal-image').click();
    },
    crop() {
      this.cropVideoFromSegment(this.uid);
      this.$refs.extendSegmentDuration.hide();
      document.getElementById('close-modal-image') &&
        document.getElementById('close-modal-image').click();
    },
  },
  created() {
    this.$root.$on('eventExtendSegmentDuration', ({ duration, uid }) => {
      this.uid = uid;
      this.duration = duration;
      this.$refs.extendSegmentDuration.show();
    });

    this.$root.$on('eventExtendDuration', ({ duration, uid }) => {
      this.uid = uid;
      this.duration = duration;
      this.extend();
    });
  },
};
</script>

<style lang="scss">
.modal-extend-segment-duration {
}
</style>



// WEBPACK FOOTER //
// ExtendSegmentDuration.vue?713a0e00